import React, { useEffect, useState } from 'react'
import { Translate } from 'react-localize-redux'
import { makeStyles } from '@material-ui/core/styles'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import { SubLink, Avatar } from 'containers'
import PersonIcon from '@material-ui/icons/Person'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from 'react-router-dom'
import { players as playersModule } from 'redux/modules'
import {
  Card,
  CardHeader,
  CardContent,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  ListItemAvatar,
  Typography,
  Tooltip,
  IconButton,
  Button,
  Box,
} from '@material-ui/core'
import CircularSpinner from 'components/loader/CircularSpinner'
import PlayerEditDialog from 'routes/PlayerDashboard/components/PlayerEditDialog'
import PropTypes from 'prop-types'
import useTeamFeature from 'hooks/useTeamFeature'
import PlayerDialog from 'containers/AddNewPlayer/components/PlayerDialog'
import { createTeamPlayerInOrganization } from 'containers/AddNewPlayer/api'
import RemovePlayerDialog from './TeamPlayersGrid/RemovePlayerDialog'
import AddPlayersDialog from './AddPlayersDialog'
import AddOrganizationTeamPlayersDialog from './AddOrganizationTeamPlayersDialog'
import { TEAM_PLAYER_DASHBOARD_ROUTE } from 'constants/routes'
import TEAM_FEATURE_FLAGS from 'constants/teamFeatureFlags'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    overflow: 'auto',
    height: 204,
    padding: theme.spacing(0),
    '& .MuiListItemSecondaryAction-root': {
      right: '12px',
    },
  },
}))

const AllPlayers = ({
  title,
  updatePlayer,
  deletePlayer,
  createTeamPlayer,
  fetchTeamPlayers,
  team,
}) => {
  const classes = useStyles()
  const fromPathname = ''
  const [initialValues, setInitialValues] = useState(null)
  const [open, setOpen] = useState(false)
  const [openAlert, setOpenAlert] = useState(false)
  const [deletePlayerUuid, setDeletePlayerUuid] = useState(null)
  const [playersArr, setPlayersArr] = useState([])
  const [loadingcircular, setLoadingCircular] = useState(false)
  const [openAddPlayers, setOpenAddPlayers] = useState(false)
  const [isOrgPlayerDialogOpen, setIsOrgPlayerDialogOpen] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)

  const { enabled: accessClubPersons } = useTeamFeature(
    TEAM_FEATURE_FLAGS.access_club_persons
  )

  const handleOpen = (player) => {
    setOpen(true)
    setInitialValues(player)
  }

  const handleClose = () => {
    setOpen(false)
    setOpenAlert(false)
    setInitialValues(null)
    setOpenAddPlayers(false)
    // update players list
    fetchTeamPlayers(team.uuid).then((result) => {
      setPlayersArr(result.response.data)
    })
  }

  const handleOrgDialogClose = () => {
    setIsOrgPlayerDialogOpen(false)
  }

  const changeEditablePlayer = (player) => {
    playersArr[playersArr.findIndex((p) => p.id === player.id)] = player
  }
  const handleDelete = () => {
    setOpenAlert(false)
    setLoadingCircular(true)
    deletePlayer(deletePlayerUuid).then(() => {
      let temp = []
      temp = playersArr.filter((obj) => obj.uuid !== deletePlayerUuid)
      setPlayersArr(temp)
      setLoadingCircular(false)
    })
  }

  const handleAlertOpen = () => {
    setOpenAlert(true)
  }

  const openAlertBox = (player) => {
    if (player) {
      setDeletePlayerUuid(player.uuid)
      handleAlertOpen()
    }
  }

  const fetchPlayers = () => {
    fetchTeamPlayers(team.uuid)
      .then((result) => {
        setPlayersArr(result.response.data)
      })
      .catch(() => {
        throw Error('Error in player API.')
      })
  }

  const handleSave = (data) => {
    setLoadingCircular(true)

    createTeamPlayer(team.uuid, {
      ...data,
      number: +data.number,
    })
      .then(() => {
        fetchPlayers()
        setLoadingCircular(false)
      })
      .catch((error) => {
        setLoadingCircular(false)
        throw Error(error)
      })
  }

  const handleAddPlayersOpen = () => {
    if (accessClubPersons) {
      setIsOrgPlayerDialogOpen(true)
    } else {
      setOpenAddPlayers(true)
    }
  }

  // Fetch players on component mount
  useEffect(() => {
    fetchPlayers()
  }, [])

  const [selectedMember, setSelectedMember] = useState(null)
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    position: 'midfield',
    number: '',
  })
  const [isNewPlayer, setIsNewPlayer] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [searchOpen, setSearchOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleSearchValue = (value) => {
    setSearchValue(value)
  }

  const handleAddClick = (member) => {
    setIsOrgPlayerDialogOpen(false)
    setOpenDialog(true)
    setErrorMessage(null)

    if (member) {
      setSelectedMember(member)
      setIsNewPlayer(false)
      setFormData({
        firstName: member.first_name || '',
        lastName: member.last_name || '',
        position: member.position || 'midfield',
        number: member.number || '',
      })
    } else {
      setSelectedMember(null)
      setIsNewPlayer(true)
      setFormData({
        firstName: searchValue.trim() || '',
        lastName: '',
        position: 'midfield',
        number: '',
      })
    }
    setSearchOpen(false)
    setSearchValue('')
    setOpenDialog(true)
  }

  const handleDialogClose = () => {
    setOpenDialog(false)
    setSelectedMember(null)
    setSearchOpen(false)
  }

  const handleCreatePlayer = () => {
    setIsLoading(true)
    const payload = {
      pde_uuid: selectedMember?.uuid || null,
      position: formData.position,
      number: formData.number,
    }

    if (!selectedMember) {
      payload.first_name = formData.firstName
      payload.last_name = formData.lastName
    }

    createTeamPlayerInOrganization(team.uuid, payload)
      .then(() => {
        fetchPlayers()
        setSearchValue('')
        setOpenDialog(false)
        setSelectedMember(null)
        setFormData({
          firstName: '',
          lastName: '',
          position: 'midfield',
          number: '',
        })
      })
      .catch((error) => {
        if (error.response && error.response.status === 409) {
          setErrorMessage(error.response.data.message)
        }
        if (
          error.response &&
          error.response.status === 422 &&
          error.response.data?.errors
        ) {
          const messages = Object.values(error.response.data.errors).flat()
          const validationErrors = messages.join(', ')
          setErrorMessage(validationErrors)
        }
        console.error('Error creating player:', error)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }
  const handleChange = (event) => {
    const { name, value } = event.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  return (
    <Card>
      {openDialog && (
        <PlayerDialog
          open={openDialog}
          onClose={handleDialogClose}
          handleCreatePlayer={handleCreatePlayer}
          handleChange={handleChange}
          formData={formData}
          isNewPlayer={isNewPlayer}
          isLoading={isLoading}
          errorMessage={errorMessage}
        />
      )}
      {openAddPlayers && !accessClubPersons && (
        <AddPlayersDialog
          open={openAddPlayers}
          onClose={handleClose}
          handleSave={handleSave}
          loadingcircular={loadingcircular}
        />
      )}
      {isOrgPlayerDialogOpen && (
        <AddOrganizationTeamPlayersDialog
          open={isOrgPlayerDialogOpen}
          onClose={handleOrgDialogClose}
          handleAddClick={handleAddClick}
          onSearchValue={handleSearchValue}
          searchOpen={searchOpen}
          onSearchValueChange={setSearchValue}
          setSearchOpen={setSearchOpen}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
        />
      )}
      <CardHeader
        title={
          <Typography variant="h4" component="h4">
            {title}
          </Typography>
        }
        action={
          <>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={handleAddPlayersOpen}
            >
              <Translate id="team-invite.add-players" />
            </Button>
          </>
        }
      />
      <CardContent className={classes.root}>
        {playersArr.length ? (
          playersArr
            .sort((a, b) =>
              a.first_name.toLowerCase() > b.first_name.toLowerCase() ? 1 : -1
            )
            .map((item) => (
              <List key={item.id} dense style={{ padding: 0 }}>
                <ListItem key={item.id}>
                  <ListItemAvatar>
                    {item.avatar ? (
                      <Avatar alt={item.first_name} src={item.avatar.full_url}>
                        <PersonIcon />
                      </Avatar>
                    ) : (
                      <Avatar alt={item.first_name}>
                        {item.first_name.charAt(0)}
                      </Avatar>
                    )}
                  </ListItemAvatar>
                  <ListItemText
                    id={1}
                    primary={
                      <SubLink
                        to={TEAM_PLAYER_DASHBOARD_ROUTE.populateURLParams({
                          playerId: item.uuid,
                        })}
                        fromPathname={fromPathname}
                        key={item.uuid}
                      >
                        <Typography variant="h4" component="h4" noWrap>
                          {item.first_name} {item.last_name}
                        </Typography>
                      </SubLink>
                    }
                    secondary={
                      item.position ? (
                        <Translate id={`player.${item.position}`} />
                      ) : null
                    }
                  />
                  <ListItemSecondaryAction>
                    <Translate>
                      {({ translate }) => (
                        <>
                          <Tooltip
                            title={translate('button.edit')}
                            placement="top"
                            arrow
                          >
                            <IconButton
                              edge="end"
                              aria-label="edit"
                              onClick={() => handleOpen(item)}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip
                            title={translate('button.remove')}
                            placement="top"
                            arrow
                          >
                            <IconButton
                              edge="end"
                              aria-label="delete"
                              onClick={() => openAlertBox(item)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </>
                      )}
                    </Translate>
                  </ListItemSecondaryAction>
                </ListItem>
              </List>
            ))
        ) : (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            sx={{ height: '100%' }}
          >
            <Box py={2}>
              <Typography variant="h5" component="h5">
                <Translate id="matches.no-players" />
              </Typography>
            </Box>
            <Box>
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={handleAddPlayersOpen}
              >
                <Translate id="team-invite.add-players" />
              </Button>
            </Box>
          </Box>
        )}
      </CardContent>
      {loadingcircular && <CircularSpinner loadingcircular={loadingcircular} />}
      {openAlert && (
        <RemovePlayerDialog
          open={openAlert}
          onClose={handleClose}
          onSubmit={handleDelete}
        />
      )}
      {open && initialValues && (
        <PlayerEditDialog
          open={open}
          handleOpen={handleOpen}
          handleClose={handleClose}
          initialValues={{ ...initialValues }}
          setInitialValues={setInitialValues}
          updatePlayer={updatePlayer}
          changeEditablePlayer={changeEditablePlayer}
          isPlayerDashboard
        />
      )}
    </Card>
  )
}

AllPlayers.defaultProps = {
  fetchTeamPlayers: () => 0,
  updatePlayer: () => 0,
}

AllPlayers.propTypes = {
  title: PropTypes.string.isRequired,
  updatePlayer: PropTypes.func,
  deletePlayer: PropTypes.func.isRequired,
  createTeamPlayer: PropTypes.func.isRequired,
  fetchTeamPlayers: PropTypes.func,
  team: PropTypes.shape({
    id: PropTypes.number.isRequired,
    uuid: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    players: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        uuid: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        position: PropTypes.string.isRequired,
      })
    ),
  }).isRequired,
}

export default compose(
  withRouter,
  connect(
    ({ team }) => ({
      team,
    }),
    {
      updatePlayer: playersModule.updatePlayer,
      deletePlayer: playersModule.deletePlayer,
      createTeamPlayer: playersModule.createTeamPlayer,
      fetchTeamPlayers: playersModule.fetchTeamPlayers,
    }
  )
)(AllPlayers)
